import { IOneGalleryBase } from '../GalleryList/Common';
import image from '../../actions/image';
import { useEffect, useRef, useState } from 'react';
import RootStore from '../../store/RootStore';
import { MessageProps, MsgImageIds } from '../../store/IMStore';
import Pubsub from '../../utils/pubsub';

interface IUseImageList {
  rootStore?: RootStore;
  gallery_list?: string[]; // 相册id列表
  currentIndex: number;
  // order: string; // 播放顺序
}

export default function(props: IUseImageList) {
  const { gallery_list, currentIndex } = props;
  // let list = [] as IOneGallery[];
  const [list, setList] = useState([] as IOneGalleryBase[]);

  if (!gallery_list?.length) {
    return {
      list
    };
  }
  const { length } = gallery_list;
  let currentGalleryListIndex = useRef(0); // 标识当前到哪个下标了
  let offsetId = useRef(0);
  const isEnd = Array(length).fill(false); //标识每一个gallery_list是否已经加载完成
  const getList = async function() {
    console.log(currentGalleryListIndex.current, 'current');
    if (currentGalleryListIndex.current >= length) {
      console.log('所有图片都已经加载完成了');
      return;
    }
    console.log(offsetId.current, currentGalleryListIndex.current, 'offsetId');
    const { total, data } = await image.list({
      sorttype: 'shoottime',
      order: 'asc',
      galleryid: +gallery_list[currentGalleryListIndex.current],
      offset: offsetId.current // 一定请求的是列表最后一项的ID作为offset，初始为0
    });
    // 看看当前相册是否有加载完，目前最简单的判断方法就是看返回的数量是否为0
    // 如果返回的条数和总条数相同，也认为已经加载完了
    if (data.length === 0 || data.length === total) {
      // 加载完了，移动到下一个下标
      isEnd[currentGalleryListIndex.current] = true;
      // 注意，current是会超出下标的，超出表示加载完所有的了！
      currentGalleryListIndex.current++;
      offsetId.current = 0; // 每次加载下一个相册时，干掉已有的offsetId
      if (data.length) {
        // 这里不应该赋值，因为已经加载完当前相册了，offsetId.current应当是0才对
        // offsetId.current = data[data.length - 1].id;
        setList(prevState => [...prevState, ...data]);
      }
    } else {
      offsetId.current = data[data.length - 1].id;
      setList(prevState => [...prevState, ...data]);
    }
    console.log(offsetId.current, 'no');
  };

  const loadMore = async function() {
    return getList();
  };

  useEffect(() => {
    getList();
  }, []);

  const deleteImageByMessage = function(ids: MsgImageIds) {
    let deleteBeforeCurrentIndexCount = 0; //删除在当前下标之前的条数
    setList(preList => {
      let newList = preList;
      if (ids instanceof Array) {
        ids.forEach(id => {
          const theIndex = newList.findIndex(one => one.id === +id);
          if (theIndex !== -1) {
            newList = [
              ...newList.slice(0, theIndex),
              ...newList.slice(theIndex + 1)
            ];
            if (theIndex <= currentIndex) deleteBeforeCurrentIndexCount++;
          }
        });
      } else {
        // 字符串
        const theIndex = newList.findIndex(one => one.id === +ids);
        if (theIndex !== -1) {
          newList = [
            ...newList.slice(0, theIndex),
            ...newList.slice(theIndex + 1)
          ];
          if (theIndex <= currentIndex) deleteBeforeCurrentIndexCount++;
        }
      }
      console.log('当前下标之前删除了', deleteBeforeCurrentIndexCount);
      Pubsub.publish(
        'modify-before-current-index',
        -deleteBeforeCurrentIndexCount
      );
      return newList;
    });
  };

  const addImageByMessage = async function(ids: MsgImageIds) {
    const imgList = await image.batchlist(ids);
    if (!imgList?.length) {
      console.warn('no batch list returned?', ids);
      return;
    }
    let addBeforeCurrentIndexCount = 0; //新增在当前下标之前的条数
    //根据shoottime排序，看看当前插入到什么位置
    setList(preList => {
      let newList = preList;
      imgList.forEach(img => {
        // 如果当前列表已经有该图片了，不需要新增进来（后台在已经显示的图片上再选择 公开会出现这种情况）
        const imgId = img.id;
        if (newList.find(one => one.id === imgId)) {
          console.log(`当前ID=${imgId}已经在列表中`);
          return;
        }
        // 升序排列时，找到第一个大于他的位置，并插入在前面
        const findLargerShootTimeIndex = newList.findIndex(
          one => +one.shoottime > +img.shoottime
        );
        console.log(findLargerShootTimeIndex, 'insert index');
        //找不到，说明新的这个比所有的都大
        if (findLargerShootTimeIndex === -1) {
          // 最后一个，并且当前gallery的列表还没有请求完，也不需要操作了，反正要被重新获取
          // 如果当前gallery列表已经请求完了，那是需要加入的，毕竟后面也不会再获取这个数据了
          // 如果当前下标已经超出数组了，也需要加入
          const currentEnd =
            currentGalleryListIndex.current === length
              ? true
              : isEnd[currentGalleryListIndex.current];
          console.log(currentEnd, 'isEnd');
          if (currentEnd) {
            newList = [...newList, img];
          }
          return;
        }
        if (findLargerShootTimeIndex === 0) {
          newList = [img, ...newList];
          if (findLargerShootTimeIndex <= currentIndex)
            addBeforeCurrentIndexCount++;
          return;
        }
        // 1~ newList.length-1/newList.length
        newList = [
          ...newList.slice(0, findLargerShootTimeIndex),
          img,
          ...newList.slice(findLargerShootTimeIndex)
        ];
        if (findLargerShootTimeIndex <= currentIndex)
          addBeforeCurrentIndexCount++;
      });
      console.log('当前下标之前新增了', addBeforeCurrentIndexCount);
      Pubsub.publish('modify-before-current-index', addBeforeCurrentIndexCount);
      console.log(newList.length, 'new list length');
      return newList;
    });
  };

  const onMessage = function(data: MessageProps) {
    if (data) {
      const { type, current_gallery, image_id, gallery_id } = data;
      // 只需要判断当前新增的image的gallery_id是否在当前已经获取到的列表中，如果新增的image在 后续列表中不需要做任何处理（因为后续反正都需要获取后面的列表）
      // 所有的处理都应该在这个判断中，否则应该无视掉这个新增
      if (
        gallery_list
          .slice(0, currentGalleryListIndex.current + 1)
          .includes(current_gallery + '')
      ) {
        if (type === 'image_add' || type === 'image_show') {
          addImageByMessage(image_id);
        } else if (type === 'image_delete' || type === 'image_hide') {
          deleteImageByMessage(image_id);
        }
      }
    }
  };

  const { imStore } = props.rootStore!;
  // 监听增减事件
  useEffect(() => {
    imStore.addMessageListener('image_add', onMessage);
    imStore.addMessageListener('image_delete', onMessage);
    imStore.addMessageListener('image_show', onMessage);
    imStore.addMessageListener('image_hide', onMessage);
    return () => {
      imStore.removeMessageListener('image_add', onMessage);
      imStore.removeMessageListener('image_delete', onMessage);
      imStore.removeMessageListener('image_show', onMessage);
      imStore.removeMessageListener('image_hide', onMessage);
    };
  }, []);

  return {
    list,
    loadMore
  };
}
